// The Apogee breakdown: every word with its points and how they were made
// (letter points, the shape bonus, the ringed planet), and the total. During
// play it reads as the score so far; once finished, as the final score.
import type { PlayScore } from '@wits/core';

interface Props {
  score: PlayScore;
  /** The server's final score once the play is finished; null during play. */
  final: number | null;
}

export function ScoreTable({ score, final }: Props) {
  const finished = final !== null;
  return (
    <div className="score-table">
      {score.words.length === 0 && <p>No constellations yet.</p>}
      {score.words.map((w) => (
        <div key={w.word} className="score-row">
          <span className="score-word">
            <span className="mono">{w.word}</span>
            <span className="score-how mono">
              {w.letters} pts{w.shapeBonusPercent > 0 ? ` · +${w.shapeBonusPercent}% shape` : ''}
              {w.planet ? ' · planet ×2' : ''}
            </span>
          </span>
          <span className="score-points mono">+{w.total}</span>
        </div>
      ))}
      <div className="score-row is-total">
        <span className="score-word">{finished ? 'Score' : 'So far'}</span>
        <span className="score-points mono">{final ?? score.running}</span>
      </div>
    </div>
  );
}
